module.exports = __webpack_public_path__ + "img/citf_logo.25d174af.png";